import React from "react";
import { useSelector } from "react-redux";
import {
  InformationContainer,
  InformationDiv,
  InformationHeading,
  MainContainer,
  ProfileDiv,
} from "../../Profile/Profile.style";

const ThanaView = () => {
  const thanaData = useSelector((state) => state.Modal.val);

  return (
    <ProfileDiv>
      <MainContainer>
      <InformationContainer>
          <InformationHeading>Thana Code :</InformationHeading>
          <InformationDiv>{thanaData.thana_code}</InformationDiv>
        </InformationContainer>
        <InformationContainer>
          <InformationHeading>Thana Name:</InformationHeading>
          <InformationDiv>{thanaData.thana_name}</InformationDiv>
        </InformationContainer>
      
        <InformationContainer>
          <InformationHeading>Upazila Code :</InformationHeading>
          <InformationDiv>{thanaData.upazila_id}</InformationDiv>
        </InformationContainer>
        <InformationContainer>
          <InformationHeading>Distict Code :</InformationHeading>
          <InformationDiv>{thanaData.distict_id}</InformationDiv>
        </InformationContainer>
        <InformationContainer>
          <InformationHeading>Distict Name :</InformationHeading>
          <InformationDiv>{thanaData.dzila_name}</InformationDiv>
        </InformationContainer>
      </MainContainer>

      

    </ProfileDiv>
  );
};

export default ThanaView;
